import React, { FC } from 'react';
import { Box, Chip, Divider, Theme, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomerType, LabClient } from 'models/client-directory';

type ClientSettingsHeaderProps = {
    labClient: LabClient;
};
const ClientSettingsHeader: FC<ClientSettingsHeaderProps> = ({ labClient }: ClientSettingsHeaderProps) => {
    const { t: translate } = useTranslation('client-directory');
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

    const chipColor = (type: CustomerType | undefined) => {
        if (type) {
            if (type == CustomerType.DENTHUB_CONNECTED) {
                return 'focus.dark';
            } else if (type == CustomerType.SUPPLIER) {
                return 'extra.dark';
            }
        }
        return 'calm.main';
    };

    const getClientType = (client: LabClient) => {
        if (client.customer?.isWhiteLabeled) {
            return isMobile
                ? translate(`client-directory:MOBILE_WHITE_LABEL`)
                : translate(`client-directory:WHITE_LABEL`);
        }
        switch (client.customer?.customerType) {
            case CustomerType.SUPPLIER:
                return isMobile
                    ? translate(`client-directory:MOBILE_LAB_CUSTOMER`)
                    : translate(`client-directory:LAB_CUSTOMER`);
            case CustomerType.MY_CLIENT:
                return isMobile
                    ? translate(`client-directory:MOBILE_MY_CLIENT`)
                    : translate(`client-directory:MY_CLIENT`);
            case CustomerType.DENTHUB_CONNECTED:
                return isMobile
                    ? translate(`client-directory:MOBILE_DENTHUB_CONNECTED`)
                    : translate(`client-directory:DENTHUB_CONNECTED`);
            default:
                return isMobile
                    ? translate(`client-directory:MOBILE_MY_CLIENT`)
                    : translate(`client-directory:MY_CLIENT`);
        }
    };
    return (
        <Box p={2}>
            <Box mb={1} display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                    <Typography variant="h1">{labClient?.clientContent?.name || labClient.customer?.name}</Typography>
                </Box>
                <Box display="flex" alignItems="center">
                    <Box mr={1}>
                        <Typography color="gray" variant="caption">
                            {labClient?.customer?._id}
                        </Typography>
                    </Box>
                    {labClient?.clientContent?.isMain ? (
                        <Chip
                            sx={{ marginRight: !isMobile ? 1 : 0.25 }}
                            label={
                                !isMobile
                                    ? translate(`client-directory:MAIN`)
                                    : translate(`client-directory:MOBILE_MAIN`)
                            }
                            size="medium"
                        />
                    ) : undefined}
                    <Chip
                        label={getClientType(labClient)}
                        size="medium"
                        variant="outlined"
                        sx={{
                            color: chipColor(labClient?.customer?.customerType),
                            borderColor: chipColor(labClient?.customer?.customerType),
                        }}
                    />
                </Box>
            </Box>
            <Divider />
        </Box>
    );
};

export default ClientSettingsHeader;
